"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomUnitLabelSubtaskType = void 0;
exports.CustomUnitLabelSubtaskType = {
    FBA_TRANSPARENCY: "FBA_TRANSPARENCY",
    MISCELLANEOUS: "MISCELLANEOUS",
    NOT_FOR_RESALE: "NOT_FOR_RESALE",
    SOLD_AS_A_SET: "SOLD_AS_A_SET",
};
//# sourceMappingURL=custom-unit-label-subtask-type.js.map